if (!customElements.get('sv-collection-strip')) {
  customElements.define('sv-collection-strip', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const track = this.querySelector('[data-sv-strip-track]'), prev = this.querySelector('[data-sv-strip-prev]'), next = this.querySelector('[data-sv-strip-next]');
      if (!track || !prev || !next) return;
      this.observer?.disconnect(); this.visibilityObserver?.disconnect();
      track.querySelectorAll('[data-sv-strip-copy]').forEach(copy => copy.remove());
      const originals = [...track.children];
      if (!originals.length) return;
      let cycle = 0;
      let hovered = false, visible = !('IntersectionObserver' in window), hasOverflow = false;
      // Keep the viewport in the middle copy. A whole-cycle relocation paints
      // identical chips, so there is no backwards animation or empty seam.
      const normalize = () => {
        if (!cycle || originals.includes(document.activeElement)) return;
        const left = track.scrollLeft;
        if (left < cycle - 1 || left >= cycle * 2) {
          track.scrollTo({ left: cycle + ((left % cycle) + cycle) % cycle, behavior: 'instant' });
        }
      };
      const update = () => {
        const previousCycle = cycle;
        const phase = previousCycle ? ((track.scrollLeft % previousCycle) + previousCycle) % previousCycle : 0;
        track.querySelectorAll('[data-sv-strip-copy]').forEach(copy => copy.remove());
        delete track.dataset.looping;
        cycle = 0;
        hasOverflow = track.scrollWidth > track.clientWidth + 1;
        if (hasOverflow) {
          const copies = () => originals.map(original => {
            const copy = original.cloneNode(true);
            copy.dataset.svStripCopy = '';
            copy.removeAttribute('id');
            copy.removeAttribute('data-shopify-editor-block');
            copy.setAttribute('aria-hidden', 'true');
            copy.tabIndex = -1;
            return copy;
          });
          track.prepend(...copies());
          track.append(...copies());
          track.dataset.looping = '';
          cycle = originals[0].getBoundingClientRect().left - track.firstElementChild.getBoundingClientRect().left;
          track.scrollTo({ left: cycle + (previousCycle ? phase / previousCycle * cycle : 0), behavior: 'instant' });
        }
        prev.hidden = next.hidden = !hasOverflow;
        sync();
      };
      const scroll = direction => {
        normalize();
        const step = (track.firstElementChild?.getBoundingClientRect().width || 180) + 12;
        track.scrollTo({ left: track.scrollLeft + direction * step, behavior: window.svMotion?.stopped() ? 'instant' : 'smooth' });
      };
      const sync = () => {
        clearInterval(this.timer);
        const run = visible && hasOverflow && !window.svMotion?.stopped() && !document.hidden && !hovered && !this.contains(document.activeElement);
        this.dataset.running = String(run);
        if (run) this.timer = setInterval(() => scroll(1), 3000);
      };
      prev.addEventListener('click', () => { scroll(-1); sync(); }, opts);
      next.addEventListener('click', () => { scroll(1); sync(); }, opts);
      track.addEventListener('scrollend', normalize, opts);
      track.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(normalize, 160);
      }, { ...opts, passive: true });
      // Visual copies remain clickable but never add duplicate keyboard stops.
      track.addEventListener('mousedown', e => {
        if (e.target.closest('[data-sv-strip-copy]')) e.preventDefault();
      }, opts);
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hovered = true; sync(); } }, opts);
      this.addEventListener('pointerleave', () => { hovered = false; sync(); }, opts);
      this.addEventListener('focusin', sync, opts);
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && sync()), opts);
      document.addEventListener('sv:motionchange', sync, opts);
      document.addEventListener('visibilitychange', sync, opts);
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
        this.visibilityObserver.observe(this);
      }
      this.observer = new ResizeObserver(update); this.observer.observe(track);
      originals.forEach(chip => this.observer.observe(chip));
      update(); sync();
    }
    disconnectedCallback() { clearInterval(this.timer); clearTimeout(this.settleTimer); this.abort?.abort(); this.observer?.disconnect(); this.visibilityObserver?.disconnect(); }
  });
}
